import _ from "lodash";
import renameVisualizationDialogTemplate from "./dialogs/rename_visualization.dialog.html";

export default function visualizationListCtrl(
    GeneratedDrawing,
    UploadedDrawing,
    $scope,
    $sbSvg,
    $sbExternalService,
    $sbCurrentProject,
    $state,
    $sbErrorPresenter,
    $mdDialog,
    $mdToast,
    $sbImageApi,
    $sbImageToSvg,
    $q,
    SABLONO_STATES,
    EVENTS,
    Analytics,
    EnvironmentFlags,
    intercomService
) {
    "ngInject";

    const VISUALIZATION_NAME_MAX_LENGTH = 120;

    /////////////////////
    //
    //      Direct variables
    //
    /////////////////////

    var vm = this;

    /////////////////////
    //
    //      SCOPE properties
    //
    /////////////////////

    vm.project = undefined;
    vm.visualizations = [];
    vm.allowedExtensions = [".svg"];
    vm.allowedLinkedDrawingExtensions = EnvironmentFlags.ImportDwfxVisualization
        ? [".svg", ".dwfx"]
        : vm.allowedExtensions;
    vm.EnvironmentFlags = EnvironmentFlags;
    vm.allowedImageExtensions = [".png", ".jpg", ".jpeg"];

    vm.loadNewFile = loadNewFile;
    vm.createSvgFromImage = createSvgFromImage;
    vm.createVisualization = createVisualization;
    vm.uploadLinkedDrawingToServer = uploadLinkedDrawingToServer;
    vm.uploadFileToServer = uploadFileToServer;
    vm.uploadDwfxToServer = uploadDwfxToServer;
    vm.uploadImageToServer = uploadImageToServer;
    vm.onWrongExtension = onWrongExtension;
    vm.showDeleteConfirmationBox = showDeleteConfirmationBox;
    vm.showRenameDialog = showRenameDialog;
    vm.deleteVisualization = deleteVisualization;
    vm.renameVisualization = renameVisualization;
    vm.navigateTo = navigateTo;
    vm.getBadgeText = getBadgeText;

    /////////////////////
    //
    //      WATCHER
    //
    /////////////////////

    //Implementing the search broadcast receiver
    $scope.$on(EVENTS.GLOBAL_SEARCH_CHANGE, function (event, eventData) {
        vm.searchTerm = {
            name: eventData.searchTerm,
        };
    });

    $scope.$on("$stateChangeSuccess", function (event, toState) {
        if (
            toState.name === SABLONO_STATES.visualizationSketch ||
            toState.name === SABLONO_STATES.visualizationGenerated ||
            toState.name === SABLONO_STATES.visualizationEditor ||
            toState.name === SABLONO_STATES.visualizationConfiguration
        ) {
            vm.substateVisible = true;
        } else {
            vm.substateVisible = false;
            activate(); // reload data when going back
        }
    });

    // I this really needed?  The activate two lines above fires when the page is navigated to :S
    // activate();

    /////////////////////
    //
    //      IMPL
    //
    /////////////////////

    function activate() {
        vm.project = $sbCurrentProject.get();
        vm.isPageLoading = true;
        vm.searchTerm = {};
        return fetchVisualizationInfoByProject(vm.project.id).finally(() => {
            vm.isPageLoading = false;
        });
    }

    function fetchVisualizationInfoByProject(projectId) {
        return $sbSvg
            .fetchAllVisualizationsByProject(projectId)
            .then(function (visualizations) {
                return $q
                    .all(
                        visualizations.map((visualization) => {
                            if (!_.isEmpty(visualization.preview)) {
                                return $sbImageApi.downloadThumbImage(
                                    projectId,
                                    visualization.preview.imageId
                                );
                            }
                            return undefined;
                        })
                    )
                    .then((images) => {
                        images.forEach(function (image, index) {
                            visualizations[index].preview.thumbnail = image;
                        });
                    })
                    .catch($sbErrorPresenter.catch)
                    .finally(() => (vm.visualizations = visualizations));
            });
    }

    function createVisualization() {
        $state.go(SABLONO_STATES.visualizationConfiguration);
    }

    function loadNewFile($event) {
        $scope.$broadcast("sbFileInput.openSvgVisualization", $event);
    }

    function uploadLinkedDrawingToServer($event, file, name, extension) {
        const normalizedExtension = (extension || "").toLowerCase();

        if (
            normalizedExtension === ".dwfx" &&
            vm.EnvironmentFlags.ImportDwfxVisualization
        ) {
            return uploadDwfxToServer($event, file);
        }

        return uploadFileToServer($event, file, name);
    }

    function createSvgFromImage($event) {
        $scope.$broadcast(
            "sbFileInput.createSvgFromImageVisualization",
            $event
        );
    }

    function uploadFileToServer($event, file, name, uploadSourceLabel) {
        _showLoadingToast();
        $sbSvg
            .uploadVisualization(file, vm.project.id, name)
            .then(function (svg) {
                Analytics.trackEvent(
                    "2D visualization",
                    "Create visualization",
                    uploadSourceLabel || "SVG uploaded"
                );
                $state.go(SABLONO_STATES.visualizationSketch, {
                    id: svg.id,
                });
                // refresh the list of available svg
                activate();
            })
            .catch((err) => {
                const DWFX_DIALOG_ERROR_MESSAGES = [
                    "ERROR_SVG_PIXELS_LIMIT_EXCEEDED",
                    "ERROR_SVG_RASTERIZATION_TIMEOUT",
                ];

                const shouldShowDwfxDialog =
                    uploadSourceLabel === "DWFX uploaded" &&
                    DWFX_DIALOG_ERROR_MESSAGES.includes(err.message);

                if (shouldShowDwfxDialog) {
                    onDwfxUploadError();
                    return;
                }

                if (err.message === "ERROR_SVG_PIXELS_LIMIT_EXCEEDED") {
                    onPixelsLimitExceeded();
                } else if (err.message === "ERROR_SVG_RASTERIZATION_TIMEOUT") {
                    onRasterizationTimeout();
                } else {
                    $sbErrorPresenter.catch(err);
                }
            })
            .finally(() => $mdToast.hide());
    }

    function uploadDwfxToServer($event, file) {
        if (!file) {
            return;
        }

        const dwfxBridge = $sbExternalService.dwfxUploadBridge();
        if (!dwfxBridge || !dwfxBridge.convertDwfxToSvg) {
            $mdDialog.show(
                $mdDialog
                    .alert()
                    .title("DIALOG_DWFX_UPLOAD_ERROR_TITLE")
                    .content("DIALOG_DWFX_UPLOAD_ERROR_CONTENT")
            );
            return;
        }

        dwfxBridge
            .convertDwfxToSvg(file)
            .then((conversionResult) => {
                const svgFileName =
                    conversionResult.svgFileName ||
                    file.name.replace(/\.dwfx$/i, ".svg");
                const svgBlob = new Blob([conversionResult.svgContent], {
                    type: "image/svg+xml",
                });
                const svgFile = new File([svgBlob], svgFileName, {
                    type: "image/svg+xml",
                });

                return uploadFileToServer(
                    $event,
                    svgFile,
                    svgFileName,
                    "DWFX uploaded"
                );
            })
            .catch((error) => {
                $sbErrorPresenter.catch(error);
            });
    }

    function uploadImageToServer($event, file, name) {
        _showLoadingToast();

        $sbImageToSvg
            .createSvgSourceFromImageFile(file)
            .then(function (svgSource) {
                const svgName = toSvgFileName(name);
                const svgFile = new File([svgSource], svgName, {
                    type: "image/svg+xml",
                });

                return $sbSvg.uploadVisualization(
                    svgFile,
                    vm.project.id,
                    svgName
                );
            })
            .then(function (svg) {
                Analytics.trackEvent(
                    "2D visualization",
                    "Create visualization",
                    "Background uploaded to create shapes"
                );
                $state.go(SABLONO_STATES.visualizationEditor, {
                    id: svg.id,
                });
                activate();
            })
            .catch($sbErrorPresenter.catch)
            .finally(() => $mdToast.hide());
    }

    /**
     * Shows the invalid extension error dialog
     */
    function onWrongExtension() {
        $mdDialog.show(
            $mdDialog
                .alert()
                .title("DIALOG_WRONG_EXTENSION_TITLE")
                .content("DIALOG_WRONG_EXTENSION_CONTENT")
        );
    }

    /** Shows the pixels limit exceed error dialog */
    function onPixelsLimitExceeded() {
        $mdDialog.show(
            $mdDialog
                .alert()
                .title("DIALOG_PIXELS_LIMIT_EXCEEDED_TITLE")
                .content("DIALOG_PIXELS_LIMIT_EXCEEDED_CONTENT")
        );
    }

    /** Shows the rasterization timeout error dialog */
    function onRasterizationTimeout() {
        $mdDialog.show(
            $mdDialog
                .alert()
                .title("DIALOG_RASTERIZATION_TIMEOUT_TITLE")
                .content("DIALOG_RASTERIZATION_TIMEOUT_CONTENT")
        );
    }

    /** Shows DWFX upload or conversion error dialog */
    function onDwfxUploadError() {
        $mdDialog
            .show(
                $mdDialog
                    .confirm()
                    .title("DIALOG_DWFX_TOO_DETAILED_TITLE")
                    .content("DIALOG_DWFX_TOO_DETAILED_CONTENT")
                    .ok("ACTION_CONTACT_SUPPORT")
                    .cancel("CLOSE")
            )
            .then(function () {
                intercomService.showNewMessage();
            });
    }

    function showDeleteConfirmationBox($event, svgKey, deleteCallback) {
        $event.stopPropagation();
        return $mdDialog
            .show(
                $mdDialog
                    .confirm()
                    .title("CONFIRM_SVG_DELETION_TITLE")
                    .content("CONFIRM_SVG_DELETION_MESSAGE")
                    .ok("YES")
                    .targetEvent($event)
            )
            .then(function onConfirm() {
                deleteCallback(svgKey)
                    .then(showDeleteSuccessToast)
                    .catch($sbErrorPresenter.catch);
            });
    }

    function deleteVisualization(svgKey) {
        return $sbSvg.removeVisualization(svgKey).then(function () {
            removeFromFrontEnd("visualizations", svgKey);
        });
    }

    function showRenameDialog($event, visualization) {
        $event.stopPropagation();
        const initialName = stripSvgSuffix(visualization.name);

        return $mdDialog
            .show({
                templateUrl: renameVisualizationDialogTemplate,
                targetEvent: $event,
                clickOutsideToClose: true,
                controllerAs: "vm",
                bindToController: true,
                controller: function RenameVisualizationDialogController(
                    $mdDialog,
                    initialName,
                    maxNameLength
                ) {
                    "ngInject";

                    this.name = initialName;
                    this.initialName = initialName;
                    this.maxNameLength = maxNameLength;
                    this.cancel = () => $mdDialog.cancel();
                    this.save = () => $mdDialog.hide(this.name);
                },
                locals: {
                    initialName,
                    maxNameLength: VISUALIZATION_NAME_MAX_LENGTH,
                },
            })
            .then(function onConfirm(name) {
                return renameVisualization(visualization, name, initialName)
                    .then(showRenameSuccessToast)
                    .catch($sbErrorPresenter.catch);
            });
    }

    function renameVisualization(visualization, name, initialName) {
        const normalizedName = (name || "").trim();

        if (!normalizedName) {
            $mdToast.show(
                $mdToast.simple().content("ERROR_VISUALIZATION_NAME_REQUIRED")
            );
            return $q.resolve();
        }

        if (normalizedName.length > VISUALIZATION_NAME_MAX_LENGTH) {
            $mdToast.show(
                $mdToast.simple().content("ERROR_VISUALIZATION_NAME_MAX_LENGTH")
            );
            return $q.resolve();
        }

        if (normalizedName === initialName) {
            return $q.resolve();
        }

        return $sbSvg
            .renameVisualization(visualization.key, normalizedName)
            .then(function ({ name: persistedName }) {
                visualization.name = persistedName;
            });
    }

    function stripSvgSuffix(name) {
        return (name || "").replace(/\.svg$/i, "");
    }

    function toSvgFileName(name) {
        const fileBaseName = (name || "")
            .trim()
            .replace(/\.[^/.]+$/, "")
            .replace(/\.svg$/i, "");

        const normalizedBaseName = fileBaseName || "visualization";
        return `${normalizedBaseName}.svg`;
    }

    function removeFromFrontEnd(listName, svgKey) {
        vm[listName] = _.filter(vm[listName], function (svg) {
            return svg.key !== svgKey;
        });
    }

    function showDeleteSuccessToast() {
        $mdToast.show(
            $mdToast.simple().content("INFO_SVG_DELETION_SUCCESSFUL")
        );
    }

    function showRenameSuccessToast() {
        $mdToast.show($mdToast.simple().content("INFO_SVG_RENAME_SUCCESSFUL"));
    }

    function navigateTo(drawing) {
        let state = SABLONO_STATES.visualizationSketch;

        if (drawing instanceof GeneratedDrawing) {
            state = SABLONO_STATES.visualizationGenerated;
        }
        return `${state}({id: ${drawing.key}})`;
    }

    function getBadgeText(drawing) {
        let sourceType = "_UPLOADED";

        if (drawing instanceof GeneratedDrawing) {
            sourceType = "_GENERATED";
        }
        return sourceType;
    }

    function _showLoadingToast() {
        return $mdToast.show(
            $mdToast
                .loading()
                .content("UPLOAD_SVG_FILE")
                .hideDelay(false)
                .position("top right")
        );
    }
}
